export * from '@bmi/services/config/config.module';
export * from '@bmi/services/config/config.service';
